import gql from 'graphql-tag'

import { SchoolListingFieldsFragment } from 'main/gql/schoolListing'

export const RELATED_PROGRAMS_QUERY = gql`
  query RelatedPrograms(
    $location: SchoolListingsLocationInput!
    $excludeSchoolIds: [Int!]
    $excludeExternalSchoolIds: [Int!]
    $limit: Int!
  ) {
    schoolListings(
      location: $location
      excludeSchoolIds: $excludeSchoolIds
      excludeExternalSchoolIds: $excludeExternalSchoolIds
      limit: $limit
    ) {
      location {
        city
        state
      }
      listings {
        ...SchoolListingFields
        profile {
          id
          ageMonthsMin
          ageMonthsMax
          enrollment
          hoursStart
          hoursEnd
          philosophy
        }
      }
    }
  }

  ${SchoolListingFieldsFragment}
`
